import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { LangContext } from "../../LanguageProvider";

const pdfPath = "/pdf/structure_2026.pdf";

export default function Structure() {
  const { translations } = useContext(LangContext);

  return (
    <Box
      sx={{
        maxWidth: "1280px",
        margin: "0 auto",
        padding: { xs: 2, md: 3 },
        marginTop: "100px",
        marginBottom: "80px",
      }}>
      <Typography
        variant="h4"
        component="h1"
        align="center"
        sx={{ fontSize: { xs: "22px", md: "28px" }, fontWeight: 700, mb: 3 }}>
        {translations["struct_college"]}
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.5 }}>
        <Button
          component="a"
          href={pdfPath}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          variant="contained"
          startIcon={<OpenInNewIcon />}
          sx={{ textTransform: "none", borderRadius: "6px" }}>
          {translations["sanitar_open_tab"]}
        </Button>
      </Box>

      <Box
        sx={{
          height: { xs: "650px", md: "850px" },
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: 2,
        }}>
        <iframe
          src={pdfPath}
          title={translations["struct_college"]}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>
    </Box>
  );
}
